import React from 'react'
import { ScaleLinear } from 'd3-scale'
import { formatSwissDate, config } from '../'
type xTickDataType = { text?: string[]; lines?: string[] }
export const XTicks = ({
  data,
  x,
  y
}: {
  data: xTickDataType
  x: ScaleLinear<string, string, never>
  y: ScaleLinear<number, number>
}) => {
  return (
    <>
      {data.lines &&
        data.lines.map((t, i) => {
          if (x(new Date(t)) > x.range()[1]) return null
          return (
            <line
              key={i}
              y1={y.range()[0] - 20}
              y2={y.range()[0] - 4}
              x1={x(new Date(t))}
              x2={x(new Date(t))}
              className='tickline'
            />
          )
        })}
      {data.text &&
        data.text.map((t, i) => {
          if (x(new Date(t)) > x.range()[1]) return null

          return (
            <text
              key={i}
              x={x(new Date(t))}
              y={y.range()[0] + config.textOffsetY}
              className='ticktext'
              textAnchor={
                i === 0
                  ? 'start'
                  : i === data.text?.length - 1
                  ? 'end'
                  : 'middle'
              }
            >
              {formatSwissDate(t, 'short')}
            </text>
          )
        })}
    </>
  )
}
